import { environmentBase } from './environment.base';
import { IEnvironment } from './environment.model';

export const environment: IEnvironment = {
  ...environmentBase,
  name:'staging'
};
